import { imageAssets, Sprite, Text, track, untrack } from "kontra";
import { Score } from "../interfaces/interfaces";

export class Fruit extends Sprite {
  isImpostor: boolean;
  levelEnded: boolean;
  gameScore: Score;
  rotationRatio: number;
  runAfterPick: Function;

  constructor(impostor = false, { dx, dy, rotation, variance }, score, runAfterPick) {
    super({
      x: 0,
      y: 0,
      image: impostor ? imageAssets['peach'] : imageAssets['mango'],
      width: 32,
      height: 32,
      dx: (Math.random() > 0.5 ? dx : -dx) + ((Math.random() * variance / 2)),// - (variance / 2)),
      dy: (Math.random() > 0.5 ? dy : -dy) + ((Math.random() * variance / 2)),// - (variance / 2)),
      onDown: () => this.pick(),
      anchor: { x: 0.5, y: 0.5 }
    });

    this.runAfterPick = runAfterPick;

    this.rotationRatio = rotation * Math.random() * (Math.random() < 0.5 ? -1 : 1);

    const { width, height } = this.context.canvas;
    this.x = Math.random() * width;
    this.y = Math.random() * height;

    Object.setPrototypeOf(this, new.target.prototype);

    this.isImpostor = impostor;
    this.gameScore = score;

    // For pointer events
    track(this);
  }

  public pick() {
    if (this.levelEnded) return;

    if (!this.isImpostor) {
      const notImpostorsClicked = +window.localStorage.getItem('not_impostors_clicked') ?? 0;
      window.localStorage.setItem('not_impostors_clicked', notImpostorsClicked + 1 + '')
    }

    this.color = !this.isImpostor ? '#DD000033' : '#00DD0033';
    this.dx = 0;
    this.dy = 0;
    this.rotationRatio = 0;
    untrack(this);

    this.runAfterPick(this.isImpostor)
  }

  public disablePicking() {
    this.levelEnded = true;
  }

  update() {
    super.update();

    this.rotation += this.rotationRatio * 0.1
    if (this.rotation >= 360 || this.rotation <= -360) {
      this.rotation = 0;
    }

    if (this.x > this.context.canvas.width + this.width) {
      this.x = 0;
    }
    if (this.x < -this.width) {
      this.x = this.context.canvas.width;
    }
    if (this.y > this.context.canvas.height + this.height) {
      this.y = 0;
    }
    if (this.y < -this.height) {
      this.y = this.context.canvas.height;
    }
  }

  render() {
    super.render();
  }
}